import { ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";
import { colors } from "./colors";

// Fallback-Hero (Logistikhalle), wenn Admin noch kein eigenes Bild gesetzt hat
const FALLBACK_HERO = "https://customer-assets.emergentagent.com/job_8871d808-9ccd-4157-8de6-34b5e308c5cc/artifacts/un2fswx6_logistikhalle-led-lichtbandinstallation-sanierung-industriebeleuchtung.png";

export function HeroSection({ scrollToSection }) {
  const [heroUrl, setHeroUrl] = useState(FALLBACK_HERO);

  useEffect(() => {
    // Lädt das Hero-Bild aus der zentralen App-Design-Einstellung (Mobile + Desktop synced)
    let cancelled = false;
    fetch("/api/public/hero-image")
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (cancelled) return;
        if (d?.url) setHeroUrl(d.url);
      })
      .catch(() => { /* Fallback bleibt */ });
    return () => { cancelled = true; };
  }, []);

  return (
    <section className="relative min-h-screen flex items-center" data-testid="hero-section">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url('${heroUrl}')`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          background: `linear-gradient(to right, ${colors.darkBlue}ee 0%, ${colors.darkBlue}bb 50%, ${colors.darkBlue}66 100%)`,
        }}
      />

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 pt-24">
        <div className="max-w-3xl">
          <p className="text-blue-400/70 text-xs md:text-sm font-medium uppercase tracking-[0.25em] mb-6">
            Montage & Installation
          </p>

          <h1
            className="text-white font-bold leading-[1.1] tracking-tight"
            style={{ fontSize: "clamp(26px, 4vw, 50px)" }}
          >
            Professionelle Montage von LED Lichtsystemen für Industrie und Logistik
          </h1>

          <p className="mt-5 md:mt-6 text-white/55 text-base md:text-lg max-w-2xl leading-relaxed">
            Planung, Modernisierung und fachgerechte Montage von Beleuchtungsanlagen
            für Produktionshallen, Lager, Büroflächen und Gewerbeobjekte.
          </p>

          <button
            onClick={() => scrollToSection("kontakt")}
            className="mt-8 md:mt-10 inline-flex items-center gap-3 text-white font-medium text-sm px-7 py-3.5 border border-white/20 hover:bg-white hover:text-gray-900 transition-all duration-300"
            data-testid="hero-cta-button"
          >
            Projekt besprechen
            <ArrowRight className="w-4 h-4 md:w-5 md:h-5" />
          </button>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 opacity-40 animate-pulse">
        <div className="w-px h-16 bg-gradient-to-b from-transparent via-white/30 to-white/60" />
      </div>
    </section>
  );
}
